import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Collapse, Dropdown, Form, Offcanvas } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import ReactCountryFlag from 'react-country-flag';
import { useTranslation } from 'react-i18next';
import {
  FaAngleDown,
  FaAngleLeft,
  FaBars,
  FaBook,
  FaDoorClosed,
  FaDoorOpen,
  FaMoneyCheck,
  FaSearch,
  FaUser,
  FaUserAlt,
} from 'react-icons/fa';
import { GrFormClose } from 'react-icons/gr';
import { MdLanguage } from 'react-icons/md';
import { Link, useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import { preferenceActions, userActions } from '../../actions';
import LogoV2 from '../../assets/logoV2.png';
import TipsListLogo from '../../assets/tips_list.png';
import StockCodeInput from '../../components/form/StockCodeInput';
import NoticeNavItem from '../../components/general/NoticeNavItem';
import { isFirefox } from '../../helpers/analytics.helper';
import useDispatch from '../../hooks/useDispatch';
import { useMediaQuery } from '../../hooks/useMediaQuery';
import { usePreferences } from '../../hooks/usePreferences';
import { useMembership, useUser } from '../../hooks/users';
import { Language } from '../../shared/types';
import IndexBarV2 from '../Ranking/IndexBarV2';
import FavoriteStockFloatingButton from '../User/FavoriteStockFloatingButton';

const logoV2 = () => {
  return (
    <img
      src={LogoV2}
      style={{ height: '1.3125rem', width: '6rem' }}
      alt="fireSpot"
    />
  );
};

const tipsLogo = () => {
  return (
    <img
      src={TipsListLogo}
      style={{ height: '0.75rem', width: '0.8125rem' }}
      alt="fireSpot"
    />
  );
};

const Style = styled.span`
  .nav-link {
    color: #303030;
  }
  .dropdown {
    font-size: 0.8125rem;
  }
  .dropdown-menu {
    min-width: 1rem;
    border: none;
    box-shadow: 0rem 0.3125rem 0.625rem rgba(0, 0, 0, 0.1);
  }
  .stock-input {
    border: 1;
    height: 2rem;
    border-radius: 3.125rem;
  }
  .navbar-brand {
    padding-top: 0rem;
  }
  .lang-switch-box {
    width: 3rem;
    height: 3rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  @media (max-width: 1200px) {
    .stock-input {
      border: 0;
      height: 2rem;
      border-radius: 0px;
      box-shadow: none;
      text-align: right;
      padding-top: 0.875rem;
      padding-right: 0rem;
    }
    .react-autosuggest__container {
      width: 100%;
    }
    .navbar {
      padding-right: 0;
    }
    .mobile-stock-code-input {
      float: left;
      width: calc(100% - 3.125rem);
    }
    .mobile-search-bar-close-icon {
      z-index: 10;
      width: 100%;
      height: 100%;
      position: absolute;
    }

    .react-autosuggest__suggestions-container {
      border: 0;
      width: 100vw;
      left: 0;
      padding: 1rem;
      height: 100vh;
      border: 1px solid #f2f2f2;
      max-height: calc(100vh - 3rem);
    }
    .mobile-search-icon {
      float: right;
    }
    .icon-box {
      width: 2.75rem;
      height: 2.75rem;
      justify-content: center;
      display: flex;
    }
    .mobile-search-bar {
      z-index: 10000000;
      background: white;
      width: 100%;
      height: 100%;
      position: fixed;
      top: 0;
      left: 0;
      overflow: auto;
    }
  }
  @media (min-width: 1200px) {
    .form-control:focus {
      border-color: #f2f2f2;
      box-shadow:
        inset 0 0.0625rem 0.125rem #f2f2f2,
        0 0 0 0.25rem #f2f2f2;
    }
    .notice-nav-item {
      padding-top: 0.5rem;
    }
    .favorite-stock-float-button {
      border-bottom: 0.0625rem solid #ffffff;
    }

    .favorite-stock-float-button:hover {
      color: #bd2b33;
      border-bottom: 0.0625rem solid;
    }

    .notice-nav-item {
      border-bottom: 0.0625rem solid #ffffff;
    }
    .notice-nav-item:hover {
      color: #bd2b33;
      border-bottom: 0.0625rem solid;
    }
  }

  .register-btn,
  .payment-btn {
    width: 5.8125rem;
    height: 1.75rem;
    background-color: #bd2b33;
    border-radius: 5px;
    border-color: #bd2b33;
    padding-top: 0rem;
    margin-top: 0.375rem;
    margin-bottom: 0.375rem;
  }
  .nav-dropdown-item {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }
  .dropdown-menu {
    top: 2.17rem;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }

  .dropdown-toggle {
    border-bottom: 0.0625rem solid #ffffff;
  }

  .dropdown-toggle:hover {
    color: #bd2b33;
    border-bottom: 0.0625rem solid;
  }

  .login-text {
    font-size: 0.8125rem;
    padding-top: 0.375rem;
    font-style: normal;
    line-height: 120%;
    font-weight: bold;
  }

  .lookup-nav-link:hover {
    color: #bd2b33;
    border-bottom: 0.0625rem solid;
  }

  .react-autosuggest__suggestion:hover {
    background-color: #f2f2f2;
  }
  .dropdown-item:hover {
    color: #bd2b33;
    background-color: #f2f2f2;
  }
  .react-autosuggest__suggestions-container {
    border-color: #f2f2f2;
  }

  .stock-input::placeholder {
    text-align: right;
    color: #919191;
    font-size: 0.8125rem;
    padding-right: 1.5625rem;
  }
  .dropdown-item {
    font-weight: bold;
    padding-top: 0.625rem;
    padding-bottom: 0.625rem;
    font-size: 0.8125rem;
  }

  #basic-nav-dropdown {
    font-weight: bold;
  }

  .react-autosuggest__container {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }
  .fa-icon {
    z-index: 10;
    height: 100%;
    position: absolute;
    top: 0.625rem;
    left: 19.875rem;
  }
`;

// eslint-disable-next-line sonarjs/cognitive-complexity
const NavBar: React.FC = () => {
  const [expanded, setExpanded] = useState(false);
  const [expandedTopNav, setExpandedTopNav] = useState(false);
  const { t, i18n } = useTranslation();
  const { lang } = usePreferences();

  useEffect(() => {
    i18n.changeLanguage(lang);
  }, [i18n, lang]);

  const user = useUser();

  const loggedIn = !!user;
  const hasMembership = useMembership();
  const isAdmin = loggedIn && user.isAdmin;

  const dispatch = useDispatch();

  const handleLogout = useCallback(() => {
    dispatch(userActions.logout());
    window.location.reload();
  }, [dispatch]);

  const onNavItemClicked = useCallback(() => {
    setExpanded(false);
  }, []);

  const breakpoint = 'xl';
  const [showSignal, setShowSignal] = useState(false);
  const [showRankingMenu, setShowRankingMenu] = useState(false);
  const [showTips, setShowTips] = useState(false);
  const [showTutorial, setShowTutorial] = useState(false);
  const [showCCASS, setShowCCASS] = useState(false);
  const [stockInput, setStockInput] = useState('');
  const [showUserMenu, setShowUserMenu] = useState(false);
  const [showLang, setShowLang] = useState(false);
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const [showMobileUserMenu, setShowMobileUserMenu] = useState(false);
  const [showSearchBar, setShowSearchBar] = useState(false);
  const isTablet = useMediaQuery('(max-width: 1200px  )');

  const handleMobileMenuClose = () => setShowMobileMenu(false);
  const handleMobileMenuShow = () => setShowMobileMenu(true);

  const navigate = useNavigate();

  const navToStock = useCallback(
    (stockCode: string) => navigate(`/lookup/${stockCode}`),
    [navigate]
  );
  const stockRankingText = t('Stock Ranking');
  const participantRankingText = t('Participant Ranking');
  const membershipAndPaymentText = t('Membership & Payment');
  const WhatsappChannelPage = 'whatsapp-channel';
  const search = useCallback(
    (stockCode: string) => {
      stockCode = stockCode.replace('^', '').toLowerCase();
      if (new RegExp('^\\d+$').test(stockCode)) {
        stockCode = stockCode.toString().padStart(5, '0');
      }
      navigate(`/lookup/${stockCode}`);
    },
    [navigate]
  );

  const isOnThatPage = useCallback((path: string) => {
    return window.location.pathname.split('/').includes(path);
  }, []);

  const handleSearch = useCallback(
    (e, _stockCode?: string) => {
      e.preventDefault();
      if (!stockInput && !_stockCode) return;
      let theStockCode = _stockCode
        ? _stockCode.toLowerCase()
        : stockInput.toLowerCase();
      if (new RegExp('^\\d+$').test(theStockCode)) {
        theStockCode = theStockCode.toString().padStart(5, '0');
      }
      navToStock(theStockCode);
    },
    [navToStock, stockInput]
  );

  const hardSetRegion = useCallback(
    region => {
      dispatch(preferenceActions.setRegion(region));
      const originalURL = window.location.href;
      const newURL = originalURL.replace(
        new RegExp('/(hk|us)/'),
        `/${region}/`
      );
      // Update the URL without reloading the page.
      window.history.pushState(null, null, newURL);
    },
    [dispatch]
  );

  const navContentTopV2 = useMemo(() => {
    return (
      <Navbar.Collapse id="basic-navbar-nav-top-V2">
        <div
          style={{
            width: hasMembership
              ? 'calc(100vw - 12.5rem)'
              : 'calc(100vw - 20rem)',
            height: '1.5rem',
            paddingLeft: '0.5rem',
            paddingTop: '0.375rem',
          }}
        >
          <IndexBarV2 />
        </div>
        <Nav className="ms-auto" style={{ gap: '1rem' }}>
          <NavDropdown
            key="lang"
            align="start"
            onMouseEnter={() => {
              setShowLang(true);
            }}
            onMouseLeave={() => setShowLang(false)}
            onClick={() => setShowLang(!showLang)}
            show={showLang}
            title={<MdLanguage size={18} />}
            style={
              loggedIn ? { paddingTop: '0.125rem' } : { paddingTop: '0.25rem' }
            }
            id="basic-nav-dropdown"
          >
            {['en', 'zh'].map((lang: Language) => (
              <NavDropdown.Item
                onClick={() => {
                  onNavItemClicked();
                  dispatch(preferenceActions.switchLang(lang));
                }}
                key={`${lang}-switch`}
                style={{ textAlign: 'center', padding: '8px' }}
              >
                {lang === 'zh' ? '繁體中文' : 'English'}
              </NavDropdown.Item>
            ))}
          </NavDropdown>
          {loggedIn && [
            <span key="notice" style={{ paddingTop: '0.125rem' }}>
              <NoticeNavItem key="notice" />
            </span>,
            <NavDropdown
              key="user"
              align="end"
              onMouseEnter={() => {
                setShowUserMenu(true);
              }}
              style={{ paddingTop: '0.125rem' }}
              onMouseLeave={() => setShowUserMenu(false)}
              show={showUserMenu}
              title={
                <span>
                  <FaUser size={16} />
                </span>
              }
              id="alignLeft basic-nav-dropdown"
            >
              <NavDropdown.Item
                onClick={onNavItemClicked}
                as={Link}
                to="/profile"
              >
                <FaBook /> {t('Profile')}
              </NavDropdown.Item>
              <NavDropdown.Item
                onClick={onNavItemClicked}
                as={Link}
                to="/payment"
              >
                <FaMoneyCheck /> {membershipAndPaymentText}
              </NavDropdown.Item>
              {isAdmin && (
                <>
                  <NavDropdown.Divider />
                  <NavDropdown.Item
                    onClick={onNavItemClicked}
                    as={Link}
                    to="/admin"
                  >
                    <FaDoorClosed /> {t('Admin')}
                  </NavDropdown.Item>
                </>
              )}
              <NavDropdown.Divider />
              <NavDropdown.Item onClick={handleLogout}>
                <FaDoorOpen /> {t('Log out')}
              </NavDropdown.Item>
            </NavDropdown>,
          ]}
          {!loggedIn && [
            <span key="notice" style={{ paddingTop: '0.125rem' }}>
              <NoticeNavItem />
            </span>,
            <Nav.Link
              className="dropdown-toggle"
              onClick={onNavItemClicked}
              key="login"
              as={Link}
              to={`/login`}
              style={{ paddingTop: '0.5625rem' }}
            >
              <span className="login-text">{t('Login')}</span>
            </Nav.Link>,
            <Link
              key="register"
              to={`/register`}
              style={{ paddingTop: '0.1875rem' }}
            >
              <Button
                className="register-btn"
                variant="danger"
                onClick={onNavItemClicked}
              >
                <span
                  style={{
                    fontSize: '0.8125rem',
                    fontStyle: 'normal',
                    lineHeight: '120%',
                    fontWeight: 'bold',
                    textAlign: 'center',
                  }}
                >
                  {t('Register')}
                </span>
              </Button>
            </Link>,
          ]}

          {loggedIn && !hasMembership && (
            <Link key="payment" to={`/payment`}>
              <Button
                className="payment-btn"
                variant="danger"
                onClick={onNavItemClicked}
              >
                <span
                  style={{
                    fontSize: '0.8125rem',
                    fontStyle: 'normal',
                    lineHeight: '120%',
                    fontWeight: 'bold',
                    textAlign: 'center',
                  }}
                >
                  {t('subscribe-member')}
                </span>
              </Button>
            </Link>
          )}
        </Nav>
      </Navbar.Collapse>
    );
  }, [
    dispatch,
    handleLogout,
    hasMembership,
    isAdmin,
    loggedIn,
    membershipAndPaymentText,
    onNavItemClicked,
    showLang,
    showUserMenu,
    t,
  ]);

  const offcanvas = useMemo(() => {
    return (
      <>
        <Offcanvas
          show={showMobileMenu}
          onHide={handleMobileMenuClose}
          placement={'end'}
          className="menu-offcanvas"
        >
          <Offcanvas.Header
            style={{
              height: '2.75rem',
              paddingRight: '0',
              boxShadow: '0rem 0.0625rem 0.625rem 0rem rgba(0, 0, 0, 0.10)',
              zIndex: 1,
            }}
          >
            <div
              style={{
                paddingLeft: '0.5rem',
                paddingBottom: '0.5rem',
                fontWeight: 'bold',
              }}
            >
              <FavoriteStockFloatingButton />
            </div>
            <div className="d-flex">
              {!loggedIn && (
                <Link
                  style={{
                    backgroundColor: '#FFFFFF',
                    color: 'black',
                    paddingRight: '0.5rem',
                    width: '3.25rem',
                    height: '2.75rem',
                    fontSize: '0.8125rem',
                    fontStyle: 'normal',
                    lineHeight: '120%',
                    fontWeight: 'bold',
                    justifyContent: 'center',
                    alignItems: 'center',
                    display: 'flex',
                  }}
                  onClick={handleMobileMenuClose}
                  key="login"
                  to={`/login`}
                >
                  <span> {t('Login')}</span>
                </Link>
              )}
              {loggedIn && (
                <span
                  onClick={() => setShowMobileUserMenu(true)}
                  style={{
                    backgroundColor: '#FFFFFF',
                    color: 'black',
                    paddingRight: '0.5rem',
                    width: '3.25rem',
                    height: '2.75rem',
                    fontStyle: 'normal',
                    lineHeight: '120%',
                    fontWeight: 'bold',
                    justifyContent: 'center',
                    alignItems: 'center',
                    display: 'flex',
                    border: 'none',
                    boxShadow: 'none',
                  }}
                >
                  <FaUserAlt style={{ color: '#000000' }} />
                </span>
              )}
              <div
                style={{
                  backgroundColor: '#BD2B33',
                  color: 'white',
                  width: '5.25rem',
                  height: '2.75rem',
                  fontSize: '0.8125rem',
                  fontStyle: 'normal',
                  lineHeight: '120%',
                  fontWeight: 'bold',
                  justifyContent: 'center',
                  alignItems: 'center',
                  display: 'flex',
                }}
              >
                {loggedIn ? (
                  hasMembership ? (
                    <span>VIP</span>
                  ) : (
                    <Nav.Link
                      onClick={() => {
                        onNavItemClicked(), handleMobileMenuClose();
                      }}
                      key="payment"
                      as={Link}
                      to={`/payment`}
                    >
                      {t('subscribe')}
                    </Nav.Link>
                  )
                ) : (
                  <Nav.Link
                    onClick={() => {
                      onNavItemClicked(), handleMobileMenuClose();
                    }}
                    key="register"
                    as={Link}
                    to={`/register`}
                  >
                    {t('register')}
                  </Nav.Link>
                )}
              </div>
            </div>
          </Offcanvas.Header>
          <Offcanvas
            show={showMobileUserMenu}
            onHide={() => setShowMobileUserMenu(false)}
            placement={'end'}
            className="menu-offcanvas"
          >
            <Offcanvas.Header
              style={{
                height: '2.75rem',
                // paddingRight: '0',
                boxShadow: '0rem 0.0625rem 0.625rem 0rem rgba(0, 0, 0, 0.10)',
                zIndex: 1,
                textAlign: 'right',
              }}
            >
              <div
                style={{
                  width: '2.75rem',
                  height: '2.75rem',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
                onClick={() => setShowMobileUserMenu(false)}
              >
                <FaAngleLeft />
              </div>
            </Offcanvas.Header>
            <Offcanvas.Body>
              <Link to={`/profile`}>
                <Button
                  className="w-100"
                  style={{
                    backgroundColor: '#FFFFFF',
                    paddingTop: '0.75rem',
                    paddingBottom: '0.75rem',
                    color: '#000000',
                    border: 'none',
                    textAlign: 'left',
                    boxShadow: 'none',
                    height: '3rem',
                    fontSize: '0.8125rem',
                    fontStyle: 'normal',
                    lineHeight: '120%',
                    fontWeight: 'bold',
                    paddingLeft: '1rem',
                    paddingRight: '1rem',
                  }}
                  onClick={() => {
                    handleMobileMenuClose();
                    setShowMobileUserMenu(false);
                  }}
                >
                  <FaBook /> {t('Profile')}
                </Button>
              </Link>
              <Link to={`/payment`}>
                <Button
                  className="w-100"
                  style={{
                    backgroundColor: '#FFFFFF',
                    paddingTop: '0.75rem',
                    paddingBottom: '0.75rem',
                    color: '#000000',
                    border: 'none',
                    textAlign: 'left',
                    boxShadow: 'none',
                    height: '3rem',
                    fontSize: '0.8125rem',
                    fontStyle: 'normal',
                    lineHeight: '120%',
                    fontWeight: 'bold',
                    paddingLeft: '1rem',
                    paddingRight: '1rem',
                  }}
                  onClick={() => {
                    handleMobileMenuClose();
                    setShowMobileUserMenu(false);
                  }}
                >
                  <FaMoneyCheck /> {membershipAndPaymentText}
                </Button>
              </Link>

              {isAdmin && (
                <>
                  <Link to={`/admin`}>
                    <Button
                      className="w-100"
                      style={{
                        backgroundColor: '#FFFFFF',
                        paddingTop: '0.75rem',
                        paddingBottom: '0.75rem',
                        color: '#000000',
                        border: 'none',
                        textAlign: 'left',
                        boxShadow: 'none',
                        height: '3rem',
                        fontSize: '0.8125rem',
                        fontStyle: 'normal',
                        lineHeight: '120%',
                        fontWeight: 'bold',
                        paddingLeft: '1rem',
                        paddingRight: '1rem',
                      }}
                      onClick={() => {
                        handleMobileMenuClose();
                        setShowMobileUserMenu(false);
                      }}
                    >
                      <FaDoorClosed /> {t('Admin')}
                    </Button>
                  </Link>
                </>
              )}
              <Link to={`/admin`}>
                <Button
                  className="w-100"
                  style={{
                    backgroundColor: '#FFFFFF',
                    paddingTop: '0.75rem',
                    paddingBottom: '0.75rem',
                    color: '#000000',
                    border: 'none',
                    textAlign: 'left',
                    boxShadow: 'none',
                    height: '3rem',
                    fontSize: '0.8125rem',
                    fontStyle: 'normal',
                    lineHeight: '120%',
                    fontWeight: 'bold',
                    paddingLeft: '1rem',
                    paddingRight: '1rem',
                  }}
                  onClick={() => {
                    handleLogout();
                    handleMobileMenuClose();
                    setShowMobileUserMenu(false);
                  }}
                >
                  <FaDoorOpen /> {t('Log out')}
                </Button>
              </Link>
            </Offcanvas.Body>
          </Offcanvas>
          <Offcanvas.Body
            style={{
              paddingTop: '0rem',
              paddingLeft: '0rem',
              paddingRight: '0rem',
            }}
          >
            <Button
              className="w-100 offcanvas-dropdown mobile-menu-dropdown-button"
              style={{
                color: '#000000',
                background: showSignal ? '#F0F0F0' : '#FFFFFF',
              }}
              onClick={() => setShowSignal(!showSignal)}
              aria-controls="collapse-signal"
              aria-expanded={showSignal}
            >
              <span>{t('Signals')} </span>
              <FaAngleDown className="d-xl-none" style={{ float: 'right' }} />
            </Button>
            <Collapse className="w-100" in={showSignal}>
              <div className="collapse-signal">
                {' '}
                {['hk', 'us'].map(region => (
                  <Dropdown.Item
                    onClick={() => {
                      hardSetRegion(region);

                      handleMobileMenuClose();
                    }}
                    as={Link}
                    to={`/${region}/signal`}
                    key={`${region}-signal-offCanvas`}
                    style={{
                      paddingLeft: '1.5rem',
                      paddingBottom: '0.75rem',
                      fontSize: '0.8125rem',
                      fontStyle: 'normal',
                      lineHeight: '120%',
                      fontWeight: 'bold',
                      height: '2.75rem',
                      paddingTop: '0.75rem',
                      background: '#F0F0F0',
                    }}
                  >
                    <ReactCountryFlag countryCode={region} svg />{' '}
                    <span style={{ paddingLeft: '0.5rem' }}>
                      {t(`${region.toUpperCase()} Signals`)}
                    </span>
                  </Dropdown.Item>
                ))}
                <div
                  style={{
                    height: '1rem',
                    width: '100%',
                    background: '#F0F0F0',
                  }}
                />
                <div
                  style={{
                    height: '0.5rem',
                    width: '100%',
                    background: '#FFFFFF',
                  }}
                />
              </div>
            </Collapse>

            <Button
              className="w-100 mobile-menu-dropdown-button"
              style={{
                color: '#000000',
                background: showRankingMenu ? '#F0F0F0' : '#FFFFFF',
              }}
              onClick={() => setShowRankingMenu(!showRankingMenu)}
              aria-controls="collapse-ranking"
              aria-expanded={showRankingMenu}
            >
              {' '}
              <span>
                {t('Statistics')}{' '}
                <FaAngleDown className="d-xl-none" style={{ float: 'right' }} />
              </span>
            </Button>
            <Collapse className="w-100" in={showRankingMenu}>
              <div className="collapse-ranking">
                {['hk', 'us'].map(region => (
                  <Dropdown.Item
                    onClick={() => {
                      hardSetRegion(region);

                      handleMobileMenuClose();
                    }}
                    style={{
                      paddingLeft: '1.5rem',
                      paddingBottom: '0.75rem',
                      fontSize: '0.8125rem',
                      fontStyle: 'normal',
                      lineHeight: '120%',
                      fontWeight: 'bold',
                      height: '2.75rem',
                      paddingTop: '0.75rem',
                      background: '#F0F0F0',
                    }}
                    as={Link}
                    to={`/${region}/ranking`}
                    key={`${region}-ranking`}
                  >
                    <ReactCountryFlag countryCode={region} svg />{' '}
                    <span style={{ paddingLeft: '0.5rem' }}>
                      {t(`${region.toUpperCase()} Statistics`)}
                    </span>
                  </Dropdown.Item>
                ))}
                <div
                  style={{
                    height: '1rem',
                    width: '100%',
                    background: '#F0F0F0',
                  }}
                />
                <div
                  style={{
                    height: '0.5rem',
                    width: '100%',
                    background: '#FFFFFF',
                  }}
                />
              </div>
            </Collapse>

            <Button
              className="w-100 mobile-menu-dropdown-button"
              style={{
                color: '#000000',
                background: showTips ? '#F0F0F0' : '#FFFFFF',
              }}
              onClick={() => setShowTips(!showTips)}
              aria-controls="collapse-tips"
              aria-expanded={showTips}
            >
              <span>
                {t('Tips')}{' '}
                <FaAngleDown className="d-xl-none" style={{ float: 'right' }} />
              </span>
            </Button>
            <Collapse className="w-100" in={showTips}>
              <div className="collapse-tips">
                {['hk', 'us'].map(region => (
                  <Dropdown.Item
                    onClick={() => {
                      hardSetRegion(region);

                      handleMobileMenuClose();
                    }}
                    style={{
                      paddingLeft: '1.5rem',
                      paddingBottom: '0.75rem',
                      fontSize: '13px',
                      fontStyle: 'normal',
                      lineHeight: '120%',
                      fontWeight: 'bold',
                      height: '44px',
                      paddingTop: '12px',
                      background: '#F0F0F0',
                    }}
                    as={Link}
                    to={`/${region}/influencer-ranking`}
                    key={`${region}-influencer-ranking`}
                  >
                    <ReactCountryFlag countryCode={region} svg />{' '}
                    <span style={{ paddingLeft: '8px' }}>
                      {t(`Influencer Ranking`)}
                    </span>
                  </Dropdown.Item>
                ))}
                <Dropdown.Item
                  onClick={handleMobileMenuClose}
                  as={Link}
                  to="/tips"
                  style={{
                    paddingLeft: '1.5rem',
                    paddingBottom: '0.75rem',
                    fontSize: '0.8125rem',
                    fontStyle: 'normal',
                    lineHeight: '120%',
                    fontWeight: 'bold',
                    height: '2.75rem',
                    paddingTop: '0.75rem',
                    background: '#F0F0F0',
                  }}
                >
                  {tipsLogo()}{' '}
                  <span style={{ paddingLeft: '0.5rem' }}>
                    {t('Tips List')}
                  </span>
                </Dropdown.Item>
                <div
                  style={{
                    height: '1rem',
                    width: '100%',
                    background: '#F0F0F0',
                  }}
                />
                <div
                  style={{
                    height: '0.5rem',
                    width: '100%',
                    background: '#FFFFFF',
                  }}
                />
              </div>
            </Collapse>

            <Link to={`/lookup`}>
              <Button
                style={{
                  backgroundColor: '#FFFFFF',
                  paddingTop: '0.75rem',
                  paddingBottom: '0.75rem',
                  color: '#000000',
                  border: 'none',
                  textAlign: 'left',
                  boxShadow: 'none',
                  height: '3rem',
                  fontSize: '0.8125rem',
                  fontStyle: 'normal',
                  lineHeight: '120%',
                  fontWeight: 'bold',
                  paddingLeft: '1rem',
                  paddingRight: '1rem',
                }}
                onClick={handleMobileMenuClose}
              >
                {t('Lookup')}
              </Button>
            </Link>
            <Button
              className="w-100 mobile-menu-dropdown-button"
              style={{
                color: '#000000',
                background: showCCASS ? '#F0F0F0' : '#FFFFFF',
              }}
              onClick={() => setShowCCASS(!showCCASS)}
              aria-controls="collapse-ccass"
              aria-expanded={showCCASS}
            >
              <span>
                CCASS+{' '}
                <FaAngleDown className="d-xl-none" style={{ float: 'right' }} />
              </span>
            </Button>
            <Collapse className="w-100" in={showCCASS}>
              <div className="collapse-ccass">
                <Dropdown.Item
                  onClick={() => {
                    handleMobileMenuClose();
                    hardSetRegion('hk');
                  }}
                  as={Link}
                  to={`/hk/ccass`}
                  style={{
                    paddingLeft: '1.5rem',
                    paddingBottom: '0.75rem',
                    fontSize: '0.8125rem',
                    fontStyle: 'normal',
                    lineHeight: '120%',
                    fontWeight: 'bold',
                    height: '2.75rem',
                    paddingTop: '0.75rem',
                    background: '#F0F0F0',
                  }}
                >
                  <ReactCountryFlag countryCode={'HK'} svg />{' '}
                  <span style={{ paddingLeft: '0.5rem' }}>{t('Search')}</span>
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={() => {
                    handleMobileMenuClose();
                    hardSetRegion('hk');
                  }}
                  as={Link}
                  to={`/hk/ccass/stock-ranking`}
                  style={{
                    paddingLeft: '1.5rem',
                    paddingBottom: '0.75rem',
                    fontSize: '0.8125rem',
                    fontStyle: 'normal',
                    lineHeight: '120%',
                    fontWeight: 'bold',
                    height: '2.75rem',
                    paddingTop: '0.75rem',
                    background: '#F0F0F0',
                  }}
                >
                  <ReactCountryFlag countryCode={'HK'} svg />{' '}
                  <span style={{ paddingLeft: '0.5rem' }}>
                    {stockRankingText}
                  </span>
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={() => {
                    handleMobileMenuClose();
                    hardSetRegion('hk');
                  }}
                  as={Link}
                  to={`/hk/ccass/participant-ranking`}
                  style={{
                    paddingLeft: '1.5rem',
                    paddingBottom: '0.75rem',
                    fontSize: '0.8125rem',
                    fontStyle: 'normal',
                    lineHeight: '120%',
                    fontWeight: 'bold',
                    height: '2.75rem',
                    paddingTop: '0.75rem',
                    background: '#F0F0F0',
                  }}
                >
                  <ReactCountryFlag countryCode={'HK'} svg />{' '}
                  <span style={{ paddingLeft: '0.5rem' }}>
                    {participantRankingText}
                  </span>
                </Dropdown.Item>
                <div
                  style={{
                    height: '1rem',
                    width: '100%',
                    background: '#F0F0F0',
                  }}
                />
                <div
                  style={{
                    height: '0.5rem',
                    width: '100%',
                    background: '#FFFFFF',
                  }}
                />
              </div>
            </Collapse>

            <Button
              className="w-100 mobile-menu-dropdown-button"
              key="tutorial"
              style={{
                color: '#000000',
                background: showTutorial ? '#F0F0F0' : '#FFFFFF',
              }}
              onClick={() => setShowTutorial(!showTutorial)}
              aria-controls="collapse-tutorial"
              aria-expanded={showTutorial}
            >
              <span>
                {t('tutorials')}{' '}
                <FaAngleDown className="d-xl-none" style={{ float: 'right' }} />
              </span>
            </Button>

            <Collapse className="w-100" in={showTutorial}>
              <div className="collapse-tutorial">
                <Dropdown.Item
                  onClick={handleMobileMenuClose}
                  as={Link}
                  to={`/video`}
                  style={{
                    paddingLeft: '1.5rem',
                    paddingBottom: '0.75rem',
                    fontSize: '0.8125rem',
                    fontStyle: 'normal',
                    lineHeight: '120%',
                    fontWeight: 'bold',
                    height: '2.75rem',
                    paddingTop: '0.75rem',
                    background: '#F0F0F0',
                  }}
                >
                  <span style={{ paddingLeft: '0.5rem' }}>{t('Videos')}</span>
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={handleMobileMenuClose}
                  as={Link}
                  to={`/tutorial`}
                  style={{
                    paddingLeft: '1.5rem',
                    paddingBottom: '0.75rem',
                    fontSize: '0.8125rem',
                    fontStyle: 'normal',
                    lineHeight: '120%',
                    fontWeight: 'bold',
                    height: '2.75rem',
                    paddingTop: '0.75rem',
                    background: '#F0F0F0',
                  }}
                >
                  <span style={{ paddingLeft: '0.5rem' }}>
                    {t('Tutorials')}
                  </span>
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={handleMobileMenuClose}
                  as={Link}
                  to="/course/datalouder-course"
                  style={{
                    paddingLeft: '1.5rem',
                    paddingBottom: '0.75rem',
                    fontSize: '0.8125rem',
                    fontStyle: 'normal',
                    lineHeight: '120%',
                    fontWeight: 'bold',
                    height: '2.75rem',
                    paddingTop: '0.75rem',
                    background: '#F0F0F0',
                  }}
                >
                  <span style={{ paddingLeft: '0.5rem' }}>
                    {t('trading-course')}
                  </span>
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={handleMobileMenuClose}
                  as={Link}
                  to="/course/datalouder-course/advance"
                  style={{
                    paddingLeft: '1.5rem',
                    paddingBottom: '0.75rem',
                    fontSize: '0.8125rem',
                    fontStyle: 'normal',
                    lineHeight: '120%',
                    fontWeight: 'bold',
                    height: '2.75rem',
                    paddingTop: '0.75rem',
                    background: '#F0F0F0',
                  }}
                >
                  <span style={{ paddingLeft: '0.5rem' }}>
                    {t('advanced-course')}
                  </span>
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={handleMobileMenuClose}
                  as={Link}
                  to="/course/datalouder-talk"
                  style={{
                    paddingLeft: '1.5rem',
                    paddingBottom: '0.75rem',
                    fontSize: '0.8125rem',
                    fontStyle: 'normal',
                    lineHeight: '120%',
                    fontWeight: 'bold',
                    height: '2.75rem',
                    paddingTop: '0.75rem',
                    background: '#F0F0F0',
                  }}
                >
                  <span style={{ paddingLeft: '0.5rem' }}>
                    {t('free-seminars')}
                  </span>
                </Dropdown.Item>
                <div
                  style={{
                    height: '1rem',
                    width: '100%',
                    background: '#F0F0F0',
                  }}
                />
              </div>
            </Collapse>
            <Link to={`/whatsapp-channel`}>
              <Button
                style={{
                  backgroundColor: '#FFFFFF',
                  paddingTop: '0.75rem',
                  paddingBottom: '0.75rem',
                  color: '#000000',
                  border: 'none',
                  textAlign: 'left',
                  boxShadow: 'none',
                  height: '3rem',
                  fontSize: '0.8125rem',
                  fontStyle: 'normal',
                  lineHeight: '120%',
                  fontWeight: 'bold',
                  paddingLeft: '1rem',
                  paddingRight: '1rem',
                }}
                onClick={handleMobileMenuClose}
              >
                {t('trading-squad')}
              </Button>
            </Link>
            <div
              style={{
                height: '2rem',
                width: '100%',
                background: '#FFFFFF',
              }}
            />
          </Offcanvas.Body>
          <Offcanvas.Body
            style={{
              background: 'black',
              position: 'absolute',
              height: '2.75rem',
              width: '100%',
              bottom: '0rem',
              display: 'flex',
              justifyContent: 'right',
              alignItems: 'center',
            }}
          >
            <div
              className="lang-switch-box"
              onClick={() => {
                dispatch(
                  preferenceActions.switchLang(lang === 'zh' ? 'en' : 'zh')
                );
              }}
            >
              <text
                style={{
                  color: 'white',
                  fontSize: '0.8125rem',
                  fontStyle: 'normal',
                  lineHeight: '120%',
                  fontWeight: 'bold',
                }}
              >
                <span>{lang === 'zh' ? 'ENG' : '中'}</span>
              </text>
            </div>
          </Offcanvas.Body>
        </Offcanvas>
      </>
    );
  }, [
    dispatch,
    handleLogout,
    hardSetRegion,
    hasMembership,
    isAdmin,
    lang,
    loggedIn,
    membershipAndPaymentText,
    onNavItemClicked,
    participantRankingText,
    showCCASS,
    showMobileMenu,
    showMobileUserMenu,
    showRankingMenu,
    showSignal,
    showTips,
    showTutorial,
    stockRankingText,
    t,
  ]);
  const DATALOUDER_ADVANCE_COURSE = 'datalouder-advance-course';
  const DATALOUDER_COURSE = 'datalouder-course';
  const INFLUENCER_RANKING = 'influencer-ranking';
  const STOCK_RANKING = 'stock-ranking';
  const PARTICIPANT_RANKING = 'participant-ranking';
  const DROPDOWN_BORDER_STYLE = '0.0625rem solid';
  // eslint-disable-next-line sonarjs/cognitive-complexity
  const navContent = useMemo(() => {
    const tutorialNavDropdownV2 = (
      <NavDropdown
        key="tutorial"
        title={
          <span
            style={{
              color:
                isOnThatPage('video') ||
                isOnThatPage('tutorial') ||
                isOnThatPage(DATALOUDER_COURSE) ||
                isOnThatPage(DATALOUDER_ADVANCE_COURSE)
                  ? '#bd2b33'
                  : '',
            }}
          >
            {t('tutorials')}{' '}
            <FaAngleDown className="d-xl-none" style={{ float: 'right' }} />
          </span>
        }
        id="basic-nav-dropdown"
        onMouseEnter={() => {
          setShowTutorial(true);
        }}
        onMouseLeave={() => setShowTutorial(false)}
        style={{
          display: 'inline-block',
          color:
            isOnThatPage('video') ||
            isOnThatPage('tutorial') ||
            isOnThatPage(DATALOUDER_COURSE) ||
            isOnThatPage(DATALOUDER_ADVANCE_COURSE) ||
            isOnThatPage('datalouder-talk')
              ? '#bd2b33'
              : '',
          borderBottom:
            isOnThatPage('video') ||
            isOnThatPage('tutorial') ||
            isOnThatPage(DATALOUDER_COURSE) ||
            isOnThatPage(DATALOUDER_ADVANCE_COURSE) ||
            isOnThatPage('datalouder-talk')
              ? DROPDOWN_BORDER_STYLE
              : '',
        }}
        show={showTutorial}
      >
        <NavDropdown.Item onClick={onNavItemClicked} as={Link} to={`/video`}>
          <div className="nav-dropdown-item">{t('Videos')}</div>
        </NavDropdown.Item>
        <NavDropdown.Item onClick={onNavItemClicked} as={Link} to={`/tutorial`}>
          <div className="nav-dropdown-item">{t('Tutorials')}</div>
        </NavDropdown.Item>
        <NavDropdown.Item
          onClick={onNavItemClicked}
          as={Link}
          to="/course/datalouder-course"
        >
          <div className="nav-dropdown-item">{t('trading-course')}</div>
        </NavDropdown.Item>
        <NavDropdown.Item
          onClick={onNavItemClicked}
          as={Link}
          to="/course/datalouder-course/advance"
        >
          <div className="nav-dropdown-item">{t('advanced-course')}</div>
        </NavDropdown.Item>
        <NavDropdown.Item
          onClick={onNavItemClicked}
          as={Link}
          to="/course/datalouder-talk"
        >
          <div className="nav-dropdown-item">{t('free-seminars')}</div>
        </NavDropdown.Item>
      </NavDropdown>
    );

    return (
      <Navbar.Collapse id="basic-navbar-nav-v2">
        <Nav
          style={{ gap: '1.5rem' }}
          className="compact-nav me-auto my-2 my-xl-0"
        >
          <Navbar.Brand
            className={`d-none d-${breakpoint}-inline`}
            as={Link}
            to={'/'}
          >
            {logoV2()}{' '}
          </Navbar.Brand>
          <NavDropdown
            key="signal"
            onMouseEnter={() => {
              setShowSignal(true);
            }}
            onMouseLeave={() => setShowSignal(false)}
            title={
              <span style={{ color: isOnThatPage('signal') ? '#bd2b33' : '' }}>
                {t('Signals')}{' '}
                <FaAngleDown className="d-xl-none" style={{ float: 'right' }} />
              </span>
            }
            show={showSignal}
            id="basic-nav-dropdown"
            style={{
              color: isOnThatPage('signal') ? '#bd2b33' : '',
              borderBottom: isOnThatPage('signal') ? DROPDOWN_BORDER_STYLE : '',
            }}
          >
            {['hk', 'us'].map(region => (
              <NavDropdown.Item
                onClick={() => {
                  onNavItemClicked();
                  hardSetRegion(region);
                }}
                as={Link}
                to={`/${region}/signal`}
                key={`${region}-signal`}
              >
                <div className="nav-dropdown-item">
                  <ReactCountryFlag countryCode={region} svg />
                  <span style={{ paddingLeft: '0.5rem' }}>
                    {t(`${region.toUpperCase()} Signals`)}
                  </span>
                </div>
              </NavDropdown.Item>
            ))}
          </NavDropdown>
          <NavDropdown
            key="ranking-menu"
            onMouseEnter={() => {
              setShowRankingMenu(true);
            }}
            onMouseLeave={() => setShowRankingMenu(false)}
            title={
              <span style={{ color: isOnThatPage('ranking') ? '#bd2b33' : '' }}>
                {t('Statistics')}{' '}
                <FaAngleDown className="d-xl-none" style={{ float: 'right' }} />
              </span>
            }
            show={showRankingMenu}
            id="basic-nav-dropdown"
            style={{
              color: isOnThatPage('ranking') ? '#bd2b33' : '',
              borderBottom: isOnThatPage('ranking')
                ? DROPDOWN_BORDER_STYLE
                : '',
            }}
          >
            {['hk', 'us'].map(region => (
              <NavDropdown.Item
                onClick={() => {
                  onNavItemClicked();
                  hardSetRegion(region);
                }}
                as={Link}
                to={`/${region}/ranking`}
                key={`${region}-ranking`}
              >
                <div className="nav-dropdown-item">
                  <ReactCountryFlag countryCode={region} svg />{' '}
                  <span style={{ paddingLeft: '0.5rem' }}>
                    {t(`${region.toUpperCase()} Statistics`)}
                  </span>
                </div>
              </NavDropdown.Item>
            ))}
          </NavDropdown>
          <NavDropdown
            key="tips"
            title={
              <span
                style={{
                  color:
                    isOnThatPage(INFLUENCER_RANKING) || isOnThatPage('tips')
                      ? '#bd2b33'
                      : '',
                }}
              >
                {t('Tips')}{' '}
                <FaAngleDown className="d-xl-none" style={{ float: 'right' }} />
              </span>
            }
            id="basic-nav-dropdown"
            onMouseEnter={() => {
              setShowTips(true);
            }}
            onMouseLeave={() => setShowTips(false)}
            show={showTips}
            style={{
              color:
                isOnThatPage(INFLUENCER_RANKING) || isOnThatPage('tips')
                  ? '#bd2b33'
                  : '',
              borderBottom:
                isOnThatPage(INFLUENCER_RANKING) || isOnThatPage('tips')
                  ? DROPDOWN_BORDER_STYLE
                  : '',
            }}
          >
            {['hk', 'us'].map(region => (
              <NavDropdown.Item
                onClick={() => {
                  onNavItemClicked();
                  hardSetRegion(region);
                }}
                as={Link}
                to={`/${region}/influencer-ranking`}
                key={`${region}-influencer-ranking`}
              >
                <div className="nav-dropdown-item">
                  <ReactCountryFlag countryCode={region} svg />{' '}
                  <span style={{ paddingLeft: '0.5rem' }}>
                    {t(`Influencer Ranking`)}
                  </span>
                </div>
              </NavDropdown.Item>
            ))}
            <NavDropdown.Item onClick={onNavItemClicked} as={Link} to="/tips">
              <div className="nav-dropdown-item">
                {tipsLogo()}{' '}
                <span style={{ paddingLeft: '0.5rem' }}>{t('Tips List')}</span>
              </div>
            </NavDropdown.Item>
          </NavDropdown>

          <Nav.Link
            onClick={onNavItemClicked}
            key="lookup"
            as={Link}
            to={`/lookup`}
            style={{
              fontWeight: 'bold',
              fontSize: '0.8125rem',
              color: isOnThatPage('lookup') ? '#bd2b33' : '',
              borderBottom: isOnThatPage('lookup') ? DROPDOWN_BORDER_STYLE : '',
            }}
            className="lookup-nav-link"
          >
            <span style={{ color: isOnThatPage('lookup') ? '#bd2b33' : '' }}>
              {t('Lookup')}
            </span>
          </Nav.Link>
          <NavDropdown
            key="ccass"
            title={
              <span
                style={{
                  color:
                    isOnThatPage('ccass') ||
                    isOnThatPage(STOCK_RANKING) ||
                    isOnThatPage(PARTICIPANT_RANKING)
                      ? '#bd2b33'
                      : '',
                }}
              >
                CCASS+{' '}
                <FaAngleDown className="d-xl-none" style={{ float: 'right' }} />
              </span>
            }
            id="basic-nav-dropdown"
            onMouseEnter={() => {
              setShowCCASS(true);
            }}
            onMouseLeave={() => setShowCCASS(false)}
            show={showCCASS}
            style={{
              color:
                isOnThatPage('ccass') ||
                isOnThatPage(STOCK_RANKING) ||
                isOnThatPage(PARTICIPANT_RANKING)
                  ? '#bd2b33'
                  : '',
              borderBottom:
                isOnThatPage('ccass') ||
                isOnThatPage(STOCK_RANKING) ||
                isOnThatPage(PARTICIPANT_RANKING)
                  ? DROPDOWN_BORDER_STYLE
                  : '',
            }}
          >
            <NavDropdown.Item
              onClick={() => {
                onNavItemClicked();
                hardSetRegion('hk');
              }}
              as={Link}
              to={`/hk/ccass`}
            >
              <div className="nav-dropdown-item">
                <ReactCountryFlag countryCode={'HK'} svg />{' '}
                <span style={{ paddingLeft: '0.5rem' }}>{t('Search')}</span>
              </div>
            </NavDropdown.Item>
            <NavDropdown.Item
              onClick={() => {
                onNavItemClicked();
                hardSetRegion('hk');
              }}
              as={Link}
              to={`/hk/ccass/stock-ranking`}
            >
              <div className="nav-dropdown-item">
                <ReactCountryFlag countryCode={'HK'} svg />{' '}
                <span style={{ paddingLeft: '0.5rem' }}>
                  {' '}
                  {stockRankingText}
                </span>
              </div>
            </NavDropdown.Item>
            <NavDropdown.Item
              onClick={() => {
                onNavItemClicked();
                hardSetRegion('hk');
              }}
              as={Link}
              to={`/hk/ccass/participant-ranking`}
            >
              <div className="nav-dropdown-item">
                <ReactCountryFlag countryCode={'HK'} svg />{' '}
                <span style={{ paddingLeft: '0.5rem' }}>
                  {' '}
                  {participantRankingText}
                </span>
              </div>
            </NavDropdown.Item>
          </NavDropdown>
          {tutorialNavDropdownV2}
          <Nav.Link
            onClick={onNavItemClicked}
            key={WhatsappChannelPage}
            as={Link}
            to={`/whatsapp-channel`}
            style={{
              fontWeight: 'bold',
              fontSize: '0.8125rem',
              color: isOnThatPage(WhatsappChannelPage) ? '#bd2b33' : '',
              borderBottom: isOnThatPage(WhatsappChannelPage)
                ? DROPDOWN_BORDER_STYLE
                : '',
            }}
            className="lookup-nav-link"
          >
            <span
              style={{
                color: isOnThatPage(WhatsappChannelPage) ? '#bd2b33' : '',
              }}
            >
              {t('trading-squad')}
            </span>
          </Nav.Link>
        </Nav>
        <div className=" d-flex">
          <div style={{ paddingRight: '1rem', fontWeight: 'bold' }}>
            <FavoriteStockFloatingButton />
          </div>
          <Form
            className=" d-xl-block d-none"
            onSubmit={handleSearch}
            style={{
              width: '21.6875rem',
              height: '3rem',
              position: 'relative',
            }}
          >
            {!isFirefox() && (
              // firefox doesn't support ::padding { padding...}
              // causing the icon overlapping with the placeholder
              // so disabling the icon for firefox.
              <div
                className="fa-icon"
                onClick={() => stockInput !== '' && navToStock(stockInput)}
              >
                <FaSearch />
              </div>
            )}
            <StockCodeInput
              value={stockInput}
              onChange={e => {
                setStockInput(e);
              }}
              onKeyPress={e => {
                stockInput !== '' && e.key === 'Enter' && handleSearch(e);
              }}
              onSelected={search}
            />
          </Form>
        </div>
      </Navbar.Collapse>
    );
  }, [
    isOnThatPage,
    t,
    showTutorial,
    onNavItemClicked,
    breakpoint,
    showSignal,
    showRankingMenu,
    showTips,
    showCCASS,
    stockRankingText,
    participantRankingText,
    handleSearch,
    stockInput,
    search,
    hardSetRegion,
    navToStock,
  ]);

  return (
    <Style>
      <div>
        <div>
          {' '}
          <Navbar
            expand={breakpoint}
            expanded={expandedTopNav}
            variant="light"
            onToggle={() => setExpandedTopNav(value => !value)}
            style={{ background: 'var(--Color, #FFF)' }}
          >
            {navContentTopV2}
          </Navbar>
        </div>
        <div>
          {' '}
          <Navbar
            expand={breakpoint}
            expanded={expanded}
            variant="light"
            style={{ backgroundColor: '#FFFFFF', height: '3rem' }}
            onToggle={() => setExpanded(value => !value)}
          >
            <Navbar.Brand
              className={`d-${breakpoint}-none`}
              as={Link}
              to={'/'}
              onClick={() => setExpanded(false)}
            >
              {logoV2()}
            </Navbar.Brand>
            <div className="d-flex d-xl-none">
              <div
                style={{
                  width: '2.75rem',
                  height: '2.75rem',
                  display: 'flex',
                  justifyContent: 'center',
                }}
                onClick={() => {
                  setShowSearchBar(true);
                  window.setTimeout(() => {
                    const input = document.querySelector<HTMLInputElement>(
                      '.mobile-stock-code-input input.stock-input'
                    );
                    if (input) input.focus();
                  }, 100);
                }}
              >
                <span style={{ paddingTop: '0.5rem' }}>
                  <FaSearch style={{ margin: 'auto' }} />
                </span>
              </div>
              <div
                style={{
                  width: '2.75rem',
                  height: '2.75rem',
                  display: 'flex',
                  justifyContent: 'center',
                }}
              >
                <span style={{ paddingTop: '0.125rem' }}>
                  <NoticeNavItem key="notice" />
                </span>
              </div>
              <div
                style={{
                  width: '2.75rem',
                  height: '2.75rem',
                  display: 'flex',
                  justifyContent: 'center',
                }}
              >
                <span style={{ paddingTop: '0.5rem' }}>
                  <FaBars onClick={handleMobileMenuShow} />
                </span>
              </div>
            </div>
            {navContent}
          </Navbar>
          {offcanvas}
          {isTablet && showSearchBar && (
            <div className="mobile-search-bar">
              <div className="mobile-stock-code-input">
                <div
                  className="mobile-search-bar-close-icon icon-box"
                  onClick={() => setShowSearchBar(false)}
                >
                  <span style={{ paddingTop: '1rem' }}>
                    {' '}
                    <GrFormClose style={{ margin: 'auto' }} />
                  </span>
                </div>
                <StockCodeInput
                  value={stockInput}
                  onChange={e => setStockInput(e)}
                  onKeyPress={e => {
                    stockInput !== '' &&
                      e.key === 'Enter' &&
                      (handleSearch(e), setShowSearchBar(false));
                  }}
                  onSelected={e => {
                    search(e);
                    setShowSearchBar(false);
                  }}
                />
              </div>
              <div
                className="mobile-search-icon icon-box"
                onClick={() =>
                  stockInput !== '' &&
                  (navToStock(stockInput), setShowSearchBar(false))
                }
              >
                <span style={{ paddingTop: '1rem' }}>
                  {' '}
                  <FaSearch style={{ margin: 'auto' }} />
                </span>
              </div>
            </div>
          )}
          <div
            className="d-flex d-xl-none"
            style={{
              width: 'calc(100vw)',
              height: '1.5rem',
              paddingLeft: '0.5rem',
              marginTop: '0.5rem',
              marginBottom: '0.5rem',
            }}
          >
            <IndexBarV2 />
          </div>
        </div>
      </div>
    </Style>
  );
};

export default NavBar;
